<template>
  <td class="text-xs-right">
    <router-link :to="{ name: route, params: { id: id }}">{{ text }}</router-link>
  </td>
</template>

<script>
export default {
  props: [ 'route', 'id', 'text' ]
}
</script>
